<mat-form-field fxFlex="100" style="width: 100%" [appearance]="appearance" floatLabel="always">
    <mat-label>
        <ng-container *ngIf="multiSelect">{{ 'bcmCostCenters.labels.multi' | translate }}</ng-container>
        <ng-container *ngIf="!multiSelect">{{ 'bcmCostCenters.labels.single' | translate }}</ng-container>
    </mat-label>

    <ng-container *ngIf="multiSelect; else singleSelect">
        <mat-select data-test="" [formControl]="formControl" multiple
                    [compareWith]="compareObjectsById">
            <mat-option *ngFor="let costCenter of (filteredCostCenters$ | async)"
                        [value]="costCenter">
                {{costCenter.name}}
            </mat-option>
        </mat-select>
    </ng-container>

    <ng-template #singleSelect>
        <input type="text" matInput [formControl]="formControl"
               [matAutocomplete]="costCenterSelector">

        <mat-autocomplete #costCenterSelector="matAutocomplete" [displayWith]="displayWith">
            <ng-container
                    *ngFor="let costCenter of (filteredCostCenters$ | async)">
                <mat-option [value]="costCenter">
                    <span>{{ costCenter.name }}</span><br>
                </mat-option>
            </ng-container>
        </mat-autocomplete>
    </ng-template>

    <button type="button" matSuffix mat-icon-button [matTooltip]="'common.clearFields' | translate"
            [disabled]="!formControl.value || formControl.disabled"
            (click)="formControl.setValue(null)">
        <mat-icon>clear</mat-icon>
    </button>

    <mat-error>{{formControl.errors | firstErrorMessage}}</mat-error>
</mat-form-field>
